import { ToggleButton, ToggleButtonGroup } from "@material-ui/lab";
import classes from 'components/CheckIn/CheckInToggleGroup/CheckinToggleGroup.module.scss';
import Constants from 'config/constants';
import CheckInTextField from 'components/CheckIn/CheckInTextField/CheckInTextField';
import ClothingShirt from 'assets/svg/clothing_shirt.svg';
import ClothingSweater from 'assets/svg/clothing_sweater.svg';
import ClothingJacket from 'assets/svg/clothing_jacket.svg';
import ClothingOther from 'assets/svg/clothing_other.svg';
import VehicleSuv from 'assets/svg/vehicle_suv.svg';
import VehiclePickup from 'assets/svg/vehicle_pickup.svg';
import VehicleSedan from 'assets/svg/vehicle_sedan.svg';
import VehicleMinivan from 'assets/svg/vehicle_minivan.svg';
import VehicleHatchback from 'assets/svg/vehicle_hatchback.svg';
import VehicleOther from 'assets/svg/vehicle_other.svg';

export default function CheckInToggleGroup(props) {

    const vehicleTypeOptions = [
        {text: 'SUV', src: VehicleSuv},
        {text: 'Pickup', src: VehiclePickup},
        {text: 'Sedan', src: VehicleSedan},
        {text: 'Minivan', src: VehicleMinivan},
        {text: 'Hatchback', src: VehicleHatchback},
        {text: 'Other', src: VehicleOther}
    ];

    const vehicleColorOptions = [
        {text: 'Black', color: '#000000'},
        {text: 'White', color: '#FFFFFF'},
        {text: 'Gray', color: '#4F4F4F'},
        {text: 'Silver', color: '#EDEDED'},
        {text: 'Blue', color: '#335069'},
        {text: 'Red', color: '#B80818'},
        {text: 'Tan', color: '#CF8A58'},
        {text: 'Gold', color: '#FFA203'},
        {text: 'Green', color: '#269E8A'},
        {text: 'Other', color: '#C8C8C8'},
    ];

    const clothingTypeOptions = [
        {text: 'Shirt', src: ClothingShirt},
        {text: 'Sweater', src: ClothingSweater},
        {text: 'Jacket', src: ClothingJacket},
        {text: 'Other', src: ClothingOther}
    ];

    const clothingColorOptions = [
        {text: 'Red', color: '#B80818'},
        {text: 'Orange', color: '#F6841F'},
        {text: 'Yellow', color: '#FFD655'},
        {text: 'Green', color: '#269E8A'},
        {text: 'Blue', color: '#388DAE'},
        {text: 'Black', color: '#000000'},
        {text: 'White', color: '#FFFFFF'},
        {text: 'Gray', color: '#4F4F4F'},
        {text: 'Brown', color: '#A37859'},
        {text: 'Other', color: '#C8C8C8'},
    ];

    const inStoreLocations = [
        'Registers',
        'Order Pickup Area',
        'Other'
    ];

    const determineCheckInTypeOptions = () => {
        return props.checkInType === Constants.CHECK_IN_CURBSIDE ? vehicleTypeOptions : clothingTypeOptions;
    };

    const determineCheckInColorOptions = () => {
        return props.checkInType === Constants.CHECK_IN_CURBSIDE ? vehicleColorOptions : clothingColorOptions;
    };

    const getTypeTextfieldLabels = () => {
        return props.checkInType === Constants.CHECK_IN_CURBSIDE ? Constants.CHECK_IN_CURBSIDE_TYPE_TEXTFIELD_LABELS : Constants.CHECK_IN_STORE_TYPE_TEXTFIELD_LABELS
    };

    const getColorTextFieldLabels = () => {
        return props.checkInType === Constants.CHECK_IN_CURBSIDE ? Constants.CHECK_IN_CURBSIDE_COLOR_TEXTFIELD_LABELS : Constants.CHECK_IN_STORE_COLOR_TEXTFIELD_LABELS
    };

    const determineTypeButtonStyling = (type) => {
        return props.checkInType === Constants.CHECK_IN_CURBSIDE ?
            (props.typeSelected === type ? classes.TypeToggleBtnActive : classes.TypeToggleBtn)
            :
            (props.typeSelected === type ? classes.TypeToggleBtnInStoreActive : classes.TypeToggleBtnInStore)
    }

    return (
        <div className={classes.Container}>
            <p className={classes.ToggleTitle}>
                {props.checkInType === Constants.CHECK_IN_CURBSIDE ? "TYPE: " : "TOP: "}
                {props.typeSelected ? props.typeSelected : 'SELECT'}
            </p>
            <ToggleButtonGroup
                exclusive value={props.typeSelected}
                onChange={(event, newValue) => props.setTypeSelected(newValue)}
                className={classes.ToggleContainer}
            >
                {determineCheckInTypeOptions().map((type) => (
                    <ToggleButton
                        key={type.text}
                        value={type.text}
                        variant="outlined"
                        className={determineTypeButtonStyling(type.text)}
                    >
                        <img src={type.src} alt={type.text}/>
                        <div className={classes.TypeBtnText}>{type.text}</div>
                    </ToggleButton>
                ))}
            </ToggleButtonGroup>
            {props.typeSelected === 'Other' &&
                <CheckInTextField value={props.typeTextFieldValue}
                                  setValue={props.setTypeTextFieldValue}
                                  labels={getTypeTextfieldLabels()}
                />
            }
            <p className={classes.ToggleTitle}>COLOR: {props.colorSelected ? props.colorSelected : 'SELECT'}</p>
            <ToggleButtonGroup exclusive
                               value={props.colorSelected}
                               onChange={(event, newValue) => props.setColorSelected(newValue)}
                               className={classes.ToggleContainer}
            >
                {determineCheckInColorOptions().map(colorOption => (
                    <ToggleButton key={colorOption.text}
                                  value={colorOption.text}
                                  variant="outlined"
                                  className={classes.ColorToggleBtn}
                    >
                        <div
                            className={props.colorSelected === colorOption.text ?
                                colorOption.text === 'Other' ? classes.ColorDotOtherActive : classes.ColorDotActive
                                :
                                colorOption.text === 'Other' ? classes.ColorDotOther : classes.ColorDot
                            }
                            style={colorOption.text === 'Other' ? {} : {backgroundColor: colorOption.color}}
                        />
                        <div className={classes.TypeBtnText}>{colorOption.text}</div>
                    </ToggleButton>
                ))}
            </ToggleButtonGroup>
            {props.colorSelected === 'Other' &&
            <CheckInTextField value={props.colorTextFieldValue}
                              setValue={props.setColorTextFieldValue}
                              labels={getColorTextFieldLabels()}
            />
            }
            {props.checkInType === Constants.CHECK_IN_STORE &&
            <>
                <p className={classes.ToggleTitle}>Where are you located?</p>
                <ToggleButtonGroup
                    exclusive value={props.location}
                    onChange={(event, newValue) => props.setLocation(newValue)}
                    className={classes.ToggleContainer}
                >
                    {inStoreLocations.map((inStoreLocation) => (
                        <ToggleButton
                            key={inStoreLocation}
                            value={inStoreLocation}
                            variant="outlined"
                            className={props.location === inStoreLocation ? classes.TypeToggleBtnActive : classes.TypeToggleBtn}
                        >
                            <div className={classes.ToggleBtnInStoreText}>{inStoreLocation}</div>
                        </ToggleButton>
                    ))}
                </ToggleButtonGroup>
                {props.location === 'Other' &&
                <CheckInTextField value={props.locationText}
                                  setValue={props.setLocationText}
                                  labels={Constants.CHECK_IN_STORE_LOCATION_TEXTFIELD_LABELS}
                />
                }
            </>
            }
        </div>
    );
};
